import { useNavigate } from 'react-router-dom';

interface VersionEntry {
  version: string;
  date: string;
  description: string;
}

export const versionHistory: VersionEntry[] = [
  {
    version: 'ver.1.16.0',
    date: '2026/10/6',
    description: '管理者向け「証憑・資料」を追加。PDFの複数アップロード、非公開S3への原本保存、形式・ページ数検証、サムネイル一覧、店舗・日付・状態の絞り込み、全ページ閲覧と原本ダウンロードに対応。外部サービスへの送信は行わない',
  },
  {
    version: 'ver.1.15.4',
    date: '2026/9/22',
    description: '利益シミュレーターを月次損益の自由試算に整理。資金繰り・シナリオ比較・1項目だけ変える領域を撤去し、カード売上60%の小計・手数料4%・カード入金見込と「（売上−食材原価）×10%」の簡易消費税を内訳に表示。手数料と簡易税を引いた月間残額で収支分岐を再計算',
  },
  {
    version: 'ver.1.15.3',
    date: '2026/9/22',
    description: '利益シミュレーターの自由試算を先頭に配置し、その売上・食材原価・固定費を資金繰りへ連動。現金・カード・PayPay・その他キャッシュレスの金額を比率から算出し、入金遅延、簡易消費税「（売上−食材原価）×10%」、90日間の必要つなぎ資金を試算。レポート再現の専用領域を撤去',
  },
  {
    version: 'ver.1.15.2',
    date: '2026/9/22',
    description: '利益シミュレーターに全社月商360万円と510万円の仮説比較を追加。帳簿上の分岐と口座支払いの差を分解し、消費税積立・納付、借入返済、カード入金遅延、期首未入金を変えた90日間の資金繰りとつなぎ資金を試算',
  },
  {
    version: 'ver.1.15.1',
    date: '2026/9/22',
    description: 'KPIに月間売上・年間売上・年別売上を追加。月間は12か月の日別グラフ、年間は10年分の月別グラフ、年別は10年を1グラフで表示。店舗・ランチ／ディナー切替、最低目標、来客数、イベント日除外に対応',
  },
  {
    version: 'ver.1.15.0',
    date: '2026/9/22',
    description: 'KPIに利益シミュレーターを追加。客単価・来客数・営業日数・人件費・原価率・家賃・その他固定費を数値入力とスライダーで調整し、月商・粗利・営業利益・利益率・損益分岐点を即時計算。黒字化に必要な追加売上・来客数・客単価・固定費削減額、座席数からの来客数試算、基準との差を示すシナリオ比較に対応',
  },
  {
    version: 'ver.1.14.5',
    date: '2026/9/21',
    description: 'CSV取り込み画面のダウンロード手順に、提供されたAirレジの日別売上・会計明細メニューとAirメイトの日別コスト出力画面の画像を追加。スマートフォンからも画像を拡大して操作箇所を確認可能にした',
  },
  {
    version: 'ver.1.14.4',
    date: '2026/9/21',
    description: '全KPIと経営分析の営業日・時間帯集計をAirレジ基準に統一。店舗マスタにランチ／ディナーの集計終点を追加し、延長営業と翌朝の会計を各画面に反映',
  },
  {
    version: 'ver.1.14.3',
    date: '2026/9/21',
    description: '週間売上をAirレジの営業日切替に合わせ、延長営業と日跨ぎ会計も計上。ランチはディナー開始前、ディナーは翌朝05:00前の来店分とし、横軸を最終会計から2時間延長',
  },
  {
    version: 'ver.1.14.2',
    date: '2026/9/21',
    description: '週間売上をAirレジの日別売上と同じ来店日基準に修正。日跨ぎ会計も翌日0時以降の時間軸へ含め、好ENの2026年9月15日の売上差額4,840円を解消',
  },
  {
    version: 'ver.1.14.1',
    date: '2026/9/21',
    description: 'CSV取り込み画面にAirレジ会計明細とAirメイト日別コストの取得手順を追加。各リンクが出力画面を直接開くこと、対象店舗の選択方法、CSVダウンロードにはPCのWeb版を使うことを案内',
  },
  {
    version: 'ver.1.14.0',
    date: '2026/9/21',
    description: 'Airレジ会計明細をCSV内のレジIDから店舗へ自動紐づけし、AirメイトはAKRから自動判定。CSV取り込みに月別・日付×店舗の完了表を追加し、売上とコストの両CSVが店舗の営業終了後に取得・取込された日だけ○と表示。営業時間中のデータも取り込むが完了扱いにせず、日跨ぎ会計は来店日を営業日として判定',
  },
  {
    version: 'ver.1.13.2',
    date: '2026/9/21',
    description: 'CSV取り込み画面にAirレジとAirメイトのCSVダウンロード画面へのリンクを追加',
  },
  {
    version: 'ver.1.13.1',
    date: '2026/9/21',
    description: 'サイドメニューの「カレンダー」を「設定」に変更し、目標値・固定費・店舗マスタ・CSV取り込みを移動。一般ユーザーにも各画面の閲覧・編集と対応するAppSync操作を許可。大分類の折りたたみ、ユーザー別セッション内の開閉状態保存、メニューの縦スクロールに対応',
  },
  {
    version: 'ver.1.13.0',
    date: '2026/9/21',
    description: 'カレンダーにイベントページを追加。店舗・日付ごとのイベントを管理者が登録・削除でき、両店開催にも対応。登録日は週間売上、ドリンク分析、滞在時間と人数、座席稼働率ヒートマップの集計から除外し、元データは保持',
  },
  {
    version: 'ver.1.12.9',
    date: '2026/9/21',
    description: 'KPIに「座席稼働率ヒートマップ」を追加。火〜日の曜日×営業時間を色分けし、直近の完了した4営業週（または選択した1週）の1時間平均在席人数÷座席数を比較。店舗・ランチ／ディナー切替、期間移動、各マスの対象日内訳、低網羅率の日を除外するデータ不足表示に対応',
  },
  {
    version: 'ver.1.12.8',
    date: '2026/9/21',
    description: '滞在時間と人数のKPIで、滞在時間・在席人数を計算できる伝票が全体の80%未満の日はデータ不足としてグラフと座席稼働率を非表示にし、週間のピーク・平均滞在集計から除外。好ENなどで少数の有効伝票から誤解を招く低い稼働率を表示しないよう修正',
  },
  {
    version: 'ver.1.12.7',
    date: '2026/9/21',
    description: 'KPIに「滞在時間と人数」を追加。火曜〜日曜の1日1グラフで伝票作成〜会計時刻と人数から推定した時間別平均在席人数、会計時間帯別平均滞在時間、店舗マスタの座席数を表示。LOOPのランチ／ディナー分割、週選択、前週補完、推定対象件数の表示に対応',
  },
  {
    version: 'ver.1.12.6',
    date: '2026/9/21',
    description: '店舗マスタに座席数を追加。正の整数として入力・保存でき、登録済み店舗の一覧にも表示。LOOP HAMBURG 19席、好EN 43席を登録',
  },
  {
    version: 'ver.1.12.5',
    date: '2026/9/21',
    description: '週間売上の各日グラフ上部に売上÷来客数で求めた客単価を表示。来客0人の日は金額の代わりにダッシュを表示し、売上・来客・客単価・目標を読みやすく配置',
  },
  {
    version: 'ver.1.12.4',
    date: '2026/9/21',
    description: '週間売上でランチ営業のない店舗を選択した場合、LOOPのランチ／ディナー売上配分を非表示にし、目標欄を2列に調整',
  },
  {
    version: 'ver.1.12.3',
    date: '2026/9/21',
    description:
      '週間売上に表示6日間の数値サマリーを追加。6日間の売上実績と日目標合計を比較して週間達成／未達を判定し、週間目標、目標差、達成率、1日平均売上、日別達成日数を表示。前週補完を含む場合は暫定判定として補完日数を明記',
  },
  {
    version: 'ver.1.12.2',
    date: '2026/9/21',
    description:
      '週間売上の「表示6日間の日別実績」に日目標の達成／未達を示す印を追加。各日の売上、日目標、目標との差額、来客数を同じ欄で確認でき、前週から補完した実績も表示対象日の目標額と比較して判定',
  },
  {
    version: 'ver.1.12.1',
    date: '2026/9/21',
    description:
      '週間売上に月商360万円の最低目標線を追加。好ENは月250万円、LOOPは月110万円とし、LOOPは直近12か月の売上実績比率（ランチ／ディナー）で配分。各月の月曜日を除く営業日数で日割りし、さらに店舗マスタの営業時間数で時間割りした「時間あたり最低目標」を各曜日グラフへ破線表示。全社・店舗時間帯別の月間目標、実績比率の対象期間、日目標・時間目標も併記',
  },
  {
    version: 'ver.1.12.0',
    date: '2026/9/21',
    description: 'KPIにドリンク分析を追加。店舗・ランチ／ディナー別に1人あたりのアルコールとソフトドリンク注文数を火曜〜日曜の1日1グラフ（横軸は会計時刻）で表示。日付選択、未取込・人数不足のデータなし表示、分類不明の件数表示に対応。週間売上も1日1グラフに修正し、未取込曜日は前週同曜日で補完。両ページのグラフの高さを短縮。',
  },
  {
    version: 'ver.1.11.0',
    date: '2026/9/21',
    description:
      'サイドメニューに今後の指標検討ページをまとめる「KPI」カテゴリを追加し、「週間売上」を新設。LOOP HAMBURGはランチ／ディナーを店舗マスタの時間帯で分割し、好ENと合わせた3つの表示単位から選択可能。直近6営業週を古い週から最新週の順に、カードで囲まず同じ横幅の6グラフとして縦1列に表示。日付入力と前週／次週／最新の完了週ボタンで期間を変更でき、最新週が日曜まで揃わない場合は直前の完了週を初期表示。各グラフの火曜〜日曜、売上・来客数の2本線、左右軸を統一して比較できるようにした',
  },
  {
    version: 'ver.1.10.8',
    date: '2026/9/21',
    description:
      '許可外のGoogleアカウントで認証された後にログインを繰り返しても同じアカウントが自動選択される問題を修正。アクセス拒否画面から「別のアカウントでログイン」を選ぶと、次回の共通ログインだけGoogleのアカウント選択を表示し、loop2014.co.jpのアカウントへ切り替えられるようにした',
  },
  {
    version: 'ver.1.10.7',
    date: '2026/9/21',
    description:
      '売上速報をスマートフォン向けに最適化。横長テーブルを日付・店舗単位のカード表示へ切り替え、収入額、取引数、口座別金額を横スクロールなしで確認できるようにした。取引明細も各カード内で縦に展開し、PCでは従来の一覧表を維持',
  },
  {
    version: 'ver.1.10.6',
    date: '2026/9/19',
    description:
      'Slack売上速報の表示を整理。2店舗合計を先頭で強調し、店舗別売上を箇条書きに変更。長いURLはSlackのリンク記法で「明細を見る」に短縮し、重複するタグとデータソース表示を省いてスマートフォンでも読みやすくした',
  },
  {
    version: 'ver.1.10.5',
    date: '2026/9/19',
    description:
      '売上速報の取引明細を表示時に口座名の昇順で並べ替えるよう変更。同一口座内はfreee取引ID順とし、口座別合計と各取引内の支払情報も同じ口座順で表示',
  },
  {
    version: 'ver.1.10.4',
    date: '2026/9/19',
    description:
      '売上速報の日付を「2026年09月19日（土）」形式へ変更。月日を常に2桁でゼロ詰めし、曜日を日本語で併記。日次一覧と最終同期の対象日に適用',
  },
  {
    version: 'ver.1.10.3',
    date: '2026/9/19',
    description:
      '売上速報の店舗選択に「すべて（2店舗）」を追加。初期表示で好ENとLOOP HAMBURGの売上を並列取得し、2店舗合計金額と両店舗の日次・口座別・取引明細を同じ一覧で確認可能にした。従来の店舗別表示も選択肢として維持',
  },
  {
    version: 'ver.1.10.2',
    date: '2026/9/19',
    description:
      '毎日10時のfreee日次同期で2店舗分の保存が完了した後、2店舗合計・各店舗の売上と取引件数・対象日の明細リンクを1件にまとめ、SNSとAmazon Q Developer in chat applications（旧AWS Chatbot）経由でSlack「売上速報」チャンネルへ配信。手動同期では通知せず、売上速報画面は店舗・開始日・終了日のURLパラメータに対応。Slackチャネル設定と最小権限の通知用ロールをCDK管理へ追加',
  },
  {
    version: 'ver.1.10.1',
    date: '2026/9/19',
    description:
      'freee口座別金額と取引明細がNaNになる表示不具合を修正。AppSync AWSJSONの二重文字列化を解消し、旧・新形式の応答を安全に復号。画面を「売上速報」として売上分析配下の /sales/daily へ移動し、閲覧は一般ユーザーにも開放。手動再同期は管理者のみに限定',
  },
  {
    version: 'ver.1.10.0',
    date: '2026/9/19',
    description:
      'freee会計APIの本番事業所と連携し、前日分の収入取引を毎日10時（JST）に取得する日次売上連携を追加。好ENとLOOP HAMBURGをfreee部門IDで店舗に対応付け、1日・1店舗・1レコードでDynamoDBに保存。freee取引ID、摘要、明細、現金／Airレジの入金内訳をMapとして保持し、管理者専用の確認・手動再取得画面を新設',
  },
  {
    version: 'ver.1.9.0',
    date: '2026/9/19',
    description:
      '管理者・一般ユーザーの権限を分離。借入、人件費、固定費、CSV取込、目標値、店舗マスタを管理者専用カテゴリへ集約し、直URLもガード。AppSyncではセンシティブなQueryと全Mutationをadmin限定にし、viewer向け取引から担当スタッフ名、コスト明細から人件費分類、店舗一覧からAirメイトAKRを除去。経営サマリーはviewerに売上・食材費のみ、売上分析はスタッフ別売上をadminのみに表示',
  },
  {
    version: 'ver.1.8.0',
    date: '2026/9/19',
    description:
      '経営ダッシュボードのUIをリデザイン。Broadsheetを基調に、PCを常設サイドバー＋コンテキストヘッダーへ再構成し、経営・売上・コスト・設定の機能分類、シアン／マゼンタのデザイントークン、紙面調のカード・表・グラフを全画面へ適用。モバイルは同じ情報設計の右ドロワー、1列フォーム、横スクロール表へ最適化。既存のviewer/admin権限、全ルート、フィルターURL同期、集計・編集機能は維持',
  },
  {
    version: 'ver.1.7.0',
    date: '2026/9/19',
    description:
      '認証を onocomm-identity-platform の共通 Cognito Managed Login へ移行。Authorization Code + PKCE とダッシュボード専用 App Client を使用し、全 AppSync Query / Mutation の Pipeline Resolver 先頭で ID token、確認済み loop2014.co.jp メールの完全一致、ダッシュボード固有ロールを検証。管理者権限を Cognito グループから DynamoDB の (issuer, sub) 単位へ分離し、me API と Account Center 導線を追加。ペンジーくんの画面・パッケージ・デプロイ依存と旧 MCP の自動デプロイを終了',
  },
  {
    version: 'ver.1.6.0',
    date: '2026/9/19',
    description:
      'ダッシュボードの公開 URL を dashboard.loop2014.co.jp に変更。CDK で loop2014.co.jp の Route53 Hosted Zone に CloudFront の A / AAAA Alias を作成し、dashboard.loop2014.co.jp 用 ACM 証明書を us-east-1 で発行・DNS 検証する構成へ移行。CSV アップロード先 S3 の CORS 許可 Origin も新 URL に更新',
  },
  {
    version: 'ver.1.5.9',
    date: '2026/5/9',
    description:
      '食材費ページと人件費ページにも URL クエリパラメータ同期を実装。食材費（/food）は store と ym、人件費（/labor）は ym（人件費は全社管理のため store なし）に対応。例: /food?store=koen&ym=2026-04 で「好EN・2026年4月」、/labor?ym=2025-12 で「2025年12月」の画面に直接遷移。食材費ページは store 変更時に localStorage にも書き込み他ページとの整合性維持',
  },
  {
    version: 'ver.1.5.8',
    date: '2026/5/9',
    description:
      '売上分析ページにも URL クエリパラメータ同期を実装。店舗（store）／月選択（ym）／時間帯（ld）が URL に反映され、共有 URL で同じ画面が再現できる。例: /sales?store=koen&ym=2026-04&ld=dinner で「好EN・2026年4月・ディナーのみ」の売上分析画面に直接遷移可能。store 変更時は localStorage にも書き込んで他ページ（食材費・人件費・固定費等）との整合性を維持。デフォルト値は省略して URL を簡潔に',
  },
  {
    version: 'ver.1.5.7',
    date: '2026/5/9',
    description:
      'トップページのフィルター状態（店舗・期間モード・時間帯・各日付指定）を URL クエリパラメータと双方向同期。URL を共有・ブックマークすると同じ画面が再現できる。パラメータ仕様: store / period / ld / ym / wd / ymode / fy / cy / from / to。デフォルト値（store=all, ld=all, period=week 等）は省略して URL を簡潔に。例: ?period=year&ymode=calendar&cy=2025 で「年間・暦年・2025年」の画面に直接遷移可能。最新売上日プローブによる selectedWeekDate の自動セットは URL に wd 指定がある場合だけスキップして URL を尊重。replace モードで履歴を汚さない',
  },
  {
    version: 'ver.1.5.6',
    date: '2026/5/9',
    description:
      'PL/売上グラフと内訳表の日付ラベルに曜日を追加。月間・カスタムモードで「3日」だったところを「3日(土)」に統一（週間モードは既に「5/3(土)」と表示済み）。曜日が一目で分かることで、平日/週末の売上傾向や定休日の把握がしやすくなる',
  },
  {
    version: 'ver.1.5.5',
    date: '2026/5/9',
    description:
      'PL/売上グラフ下のデータ点内訳表の縦横を入れ替え。これまで「行=期間／列=指標」だったが、期間ポイントが多い場合（年間12ヶ月、月間31日など）に縦に長くなり見づらかったため、「行=指標／列=期間」に変更。指標（売上・F・L・家賃・他・利益・FL率／売上・来客・組数・客単価・F/D注文数）が縦に並び、各期間が横に並ぶ。最終列に合計列を薄赤背景で強調表示。横スクロール対応で多期間でも閲覧可',
  },
  {
    version: 'ver.1.5.4',
    date: '2026/5/9',
    description:
      'トップページの PL グラフと売上グラフの下に、グラフを構成しているデータ点の内訳表を追加。PL 表は「期間 / 売上 / 食材費 F / 人件費 L / 家賃 / その他 / 利益 / FL率」、売上表は「期間 / 売上 / 来客数 / 組数 / 客単価 / フード注文数 / ドリンク注文数」を期間ポイントごとに表示し、最終行に合計行（合計売上、合計F、合計L、…と FL率／客単価は合計から再計算）。グラフの各バーや線が実数値でいくらかを把握できるようになり、月次／日次／週次のドリルダウン分析が容易に。横スクロール対応で狭い画面でも閲覧可',
  },
  {
    version: 'ver.1.5.3',
    date: '2026/5/9',
    description:
      '家賃・固定費・月額固定人件費の月別按分が「30日固定」だったために、月の日数（28〜31日）の違いで誤差が出ていた問題を修正。例: 2026年4月（30日）は月額×1.0、3月（31日）は月額×31/30 ≒ 月額×1.033 で約3.3%多く出ていた。修正後は「その日が含まれる月の日数」で割って按分するため、完全月の家賃合計＝契約月額が常に成立する。day モード（週間／月間／カスタム）と month モード（年間）の両方を対応。月跨ぎのカスタム期間や週間でも、各月の日数に応じて自然な按分になる',
  },
  {
    version: 'ver.1.5.2',
    date: '2026/5/9',
    description:
      'トップページの全KPIが¥0になっていた重大不具合を修正。原因: AppSync Query.stores の resolver がテーブル全体の Scan + Filter（SK="METADATA"）方式だったため、ジャーナル履歴 19,000+件の取込みで TXN レコードが膨大になり、Scan の単発1MB制限内に Store METADATA が含まれなくなり stores=[] が返るようになった。stores が空になると useQueries が disabled になり、トップページのほぼすべてのデータ取得が止まる連鎖的不具合が発生。修正: (1) Query.stores resolver を Scan から GSI1 Query へ変更（GSI1PK="STORES_LIST" を専用インデックスとして利用）、(2) Mutation.upsertStore に GSI1PK="STORES_LIST", GSI1SK="STORE#<id>" の自動セットを追加、(3) 既存 2 店舗（loop-hamburg / koen）の METADATA レコードに GSI1 属性をマイグレーション投入',
  },
  {
    version: 'ver.1.5.1',
    date: '2026/5/9',
    description:
      'ジャーナル履歴と会計明細の重複期間取込時の情報損失を防止。ver.1.5.0 では BatchWrite でジャーナル取込が無条件上書きされ、既に取り込まれていた会計明細データ（人数・滞在時間・席名・カテゴリを含む）がジャーナル由来データ（欠損あり）で上書きされてしまう問題があった。修正: ジャーナル取込を BatchWrite から条件付き PutItem に変更し、ConditionExpression で「既存レコードが無い／既存ソース=airregi-journal／source 属性が無い古いレコード」のいずれかの場合のみ書込みする。既存=会計明細（airregi-kaikei）の場合は ConditionalCheckFailedException でスキップし preserved カウンタに加算、取込履歴のエラー欄に「N 件は会計明細データが既に存在するためジャーナルでの上書きをスキップ」と表示。逆にジャーナルが入っている期間に会計明細を取り込めば、会計明細側の BatchWrite で自動的に上書きされ欠損項目が補完される',
  },
  {
    version: 'ver.1.5.0',
    date: '2026/5/9',
    description:
      'Airレジ「ジャーナル履歴」CSV の取込みに対応し、過去分の売上補完を可能に。Airレジ会計明細は前月1日〜本日分のみだが、ジャーナル履歴は過去全期間を取得できるため、年単位の経営分析の幅が広がる。実装: (1) Phase A — `lambda/csv-parser/src/parsers/journal.ts` 新規パーサーを追加、CSV 内の店舗番号(AKR) で Store マスタの airmateAkr から storeId を自動マッピング。取引種別「会計」のみ取込み、返金等は除外。既存 Transaction レコードと同形式で書込みつつ、欠損項目（人数 / 滞在時間 / 席名 / カテゴリ）は null、source="airregi-journal" でマーキング。(2) Phase B — UploadPage の判定にジャーナル履歴を追加、店舗選択不要（CSV内 AKR で自動判定）。csv-upload-url Lambda は raw/airregi/journal/ プレフィックスで保存。(3) Phase C — 売上ページにジャーナル混在警告バナーを追加（混在比率を表示）、isDrinkCategory にメニュー名フォールバック判定を追加（カテゴリ未設定時はメニュー名でドリンク判定）、トップページの F/D 注文数判定も同様に改修。GraphQL Transaction 型に source フィールドを追加',
  },
  {
    version: 'ver.1.4.4',
    date: '2026/5/9',
    description:
      '週間モードの食材費が ¥0 になるバグを修正。週間モードのときに costEntries クエリの範囲が `isoWeekRange(isoWeeks[0])`（12 週前の単一 ISO 週）に分岐していたため、当期の食材費（原価カテゴリ・reportInput="あり"）がまったく取得できていなかった。ver.1.4.2 でローリング 7 日に切り替えた際、isoWeeks が KPI 計算に使われなくなったが、costEntries の取得範囲分岐だけが残置されていた。すべてのモードで periodRange を costEntries に渡すよう統一',
  },
  {
    version: 'ver.1.4.3',
    date: '2026/5/9',
    description:
      '日別ポイント（週間／月間／カスタム）の家賃・その他固定費・月額固定人件費の計上判定を「その日に売上があるか」から「今日以前か」に変更。家賃は契約上の月額固定費なので、定休日や売上 0 日でも発生する。これまでは前期と当期で営業日数が違うと家賃額もずれていた（例: 前期に定休日が含まれると家賃が少なく見える）。今日以前なら営業日として一律按分するため、当期 vs 前期で同じ日数なら同額が計上され公平な比較が可能に。年間モード（月別ポイント）の hasSales 判定はそのまま維持—未取込月のコスト計上を防ぐため',
  },
  {
    version: 'ver.1.4.2',
    date: '2026/5/9',
    description:
      'トップページの週間／カスタム期間を改善。(1) 週間モードを ISO 週（月〜日固定）から「指定日を末日とした過去 7 日間（ローリング 7 日）」に変更。デフォルトの末日は最新売上日（直近 60 日 transactions の max accountDate）に自動セット—売上が登録されていない当日でもデータがある日まで自然に遡る。前期は「さらに前 7 日間」。(2) カスタム期間にも前期比較を実装：選択期間と同じ長さの直前期間（例: 4/1-4/15 の 15 日間 → 前期 3/17-3/31）を前期として KPI 比較カードを表示。(3) KPI 値の権威ソースを weeklySummary / monthlySummary から pointsTotals（buildPoints の合計）に統一—ローリング 7 日対応のため。週間／月間／カスタムは日別 buildPoints、年間のみ月別 buildPoints で動作',
  },
  {
    version: 'ver.1.4.1',
    date: '2026/5/9',
    description:
      'トップページの期間切替を再構成。(1) デフォルト期間を「月間」→「週間」に変更（普段の経営判断は週単位の振り返りが中心のため）。(2) 期間ボタンの順番を「年間／月間／週間／カスタム」→「週間／月間／年間／カスタム」に変更。(3) カスタム以外で前期との比較を実装：週間=前週／月間=前月／年間=前年同期（rolling12 / 暦年-1 / 年度-1）。前期の monthlySummary / weeklySummary / costEntries / shifts / transactions を別途取得し、当期と同じ points 計算ロジック（hasSales 判定、L/D 按分、月途中日割り）で前期 KPI を導出。(4) 当期 KPI カードに「前期比 +/-X.X%」バッジを追加—売上・利益は + 緑/- 赤、F・L・家賃・その他固定費は + 赤/- 緑（経費は減少が良）。(5) 当期カード列の直下に前期 KPI カード列を破線スタイルで並べ、当期 vs 前期を直接比較できるレイアウトに',
  },
  {
    version: 'ver.1.4.0',
    date: '2026/5/8',
    description:
      'MCP サーバーを ver.1.1.0〜1.3.x のダッシュボード刷新に追従。(1) 既存ツール拡張: get_monthly_summary / get_weekly_summary に lunchSales / dinnerSales / otherSales（各 txnCount / customerCount）と foodOrderQuantity / drinkOrderQuantity を追加。list_stores に lunchStart / lunchEnd / dinnerStart / dinnerEnd / drinkCategoryKeywords を追加。get_cost_entries の docstring を実態（FixedCostItem / LaborCostItem / Loan / Benchmark への参照）に更新。(2) 新規ツール 4 つ: get_fixed_costs（家賃含む固定費マスタ、店舗別 × 月額固定）、get_labor_costs（人件費月額固定値、暫定）、get_loans（全社借入レコード）、get_benchmark（構成比目標 F:30 / L:30 / FL:55 / 家賃:10 / 他:20 / 利益:10）。これによりペンジーくん等の AI エージェントが完全な PL 推定（売上 - F - L - 家賃 - その他固定費 = 利益）と借入返済を含む資金繰り判断を行えるようになる。MCP は Read-only を維持',
  },
  {
    version: 'ver.1.3.3',
    date: '2026/5/8',
    description:
      '売上ページの「商品分析」と「カテゴリ × 時間帯ヒートマップ」をフード／ドリンクで分割。(1) 商品 ABC 分析—「商品 ABC（売上トップ 15）」「商品明細（ABC ランク付）」をフード／ドリンクの 4 セクションに展開。各グループ内で独立に構成比と累計構成比を計算。(2) カテゴリ × 時間帯ヒートマップ—「フードカテゴリ × 時間帯」「ドリンクカテゴリ × 時間帯」の 2 グリッドに分割し、それぞれ独立スケールで描画。これにより「ビール vs 豚玉」のようにレンジが違うものを同じヒートマップ内で比較する不毛さが解消され、フード／ドリンクそれぞれのピーク時間や主力品目が純粋に把握できる。判定は店舗マスタ「ドリンク判定キーワード」がカテゴリ名に含まれるかで決定（未設定時は既定キーワード）。トップページの F/D 注文数と整合',
  },
  {
    version: 'ver.1.3.2',
    date: '2026/5/8',
    description:
      'スマホ／タブレット表示のレスポンシブ対応。AppShell をモバイル時（< 768px）にハンバーガーメニュー + 右側スライドインドロワーへ切替。ロゴはコンパクト表示、メインコンテンツ余白も縮小。ドロワーには主要機能（トップ／売上／食材費／人件費／固定費／借入）と設定（CSV取込／目標値／店舗マスタ）を縦並びでまとめ、ペンジーくん外部リンク・アカウント・ログアウト・メールアドレス表示も統合。画面遷移時の自動クローズ、表示中の背景スクロールロック、半透明オーバーレイのタップで閉じる動作を実装。useIsMobile hook（window.innerWidth 監視）を新設して PC/モバイル切替を一元管理',
  },
  {
    version: 'ver.1.3.1',
    date: '2026/5/8',
    description:
      'CSV取込のバグ修正：Macの Finder から渡されるファイル名は Unicode NFD 形式（濁点が分離）の場合があり、「シフトデータ」「会計明細」などのリテラル比較が外れて種類判定が unknown になっていた。フロント（UploadPage の isKaikei / isAirshift / isAirmateCost）、バックエンド（csv-upload-url の decideKeyPrefix、csv-parser の detectCsvTypeFromKey）すべてで NFC 正規化を入れ、Mac 由来のファイル名でも正しく `raw/airshift/shift/<storeId>/...` 等に振り分かれるよう修正',
  },
  {
    version: 'ver.1.3.0',
    date: '2026/5/8',
    description:
      '売上ページを商品ABC単独から「経営判断に追い込む詳細分析ダッシュボード」へ全面刷新。Transactions（accountTime / customerCount / stayDurationSec / receiptName / staffName / items）を活用して以下の分析ビューを実装：(1) サマリーKPI（売上・客数・客単価・組数・滞在時間、それぞれ前月比／前年同月比つき）、(2) ランチ／ディナー／その他のセグメント比較表、(3) A. 客単価分析—客単価分布ヒストグラム（500円刻み、平均ライン付）／時間帯別客単価×取引数（ComposedChart）／パーティサイズ別（1人・2人・3-4人・5人以上）、(4) B. 来客動態—曜日×時間帯ヒートマップ／日別売上推移（前月・前年同月比較ライン付）／滞在時間分布、(5) C. メニューミックス—フード/ドリンク比率の時間帯別積上げ＋ドリンク比率ライン／カテゴリ×時間帯ヒートマップ／商品ABC（既存維持）／ABC ランク付き明細、(6) D. オペレーション—スタッフ別売上・客単価／席別利用回数・1日あたり回転率／決済方法別構成。共通の集計ロジックは frontend/src/lib/salesAnalytics.ts に集約',
  },
  {
    version: 'ver.1.2.7',
    date: '2026/5/8',
    description:
      '食材費ページの「日次／週次／月次」粒度切替を廃止。月選択している時点で月内データのみ対象になるため、月次=1点で無意味、週次=4-5週で粒度切替の効果が薄かった。常に日次積上げ棒グラフ（最大31日分）に固定し、UIを簡潔化',
  },
  {
    version: 'ver.1.2.6',
    date: '2026/5/8',
    description:
      'トップページのグラフ表示を改善。(1) PL グラフと売上グラフをタブ切替から「縦並びの常時表示」に変更。同じ期間の費用構成と売上動向を一画面で比較できるようになった。(2) 時間帯別取引をヒートマップから棒グラフ（売上＝棒・左軸／取引数＝線・右軸の ComposedChart）に置き換え。色濃度では判別しにくかった時間帯ごとの差が高さで一目で分かり、ピーク時間や閑散時間の把握が容易になった',
  },
  {
    version: 'ver.1.2.5',
    date: '2026/5/8',
    description:
      '売上データのない月／日はコスト（家賃・固定費・人件費・F）を計上しないように修正。例: 2026年（暦年）を見たとき 3 月以降は CSV 取込みなしで売上 0 だが、家賃などが日割り按分されて FL 率がマイナスに見える問題を解消。KPI 値は points（月別 or 日別）の合計から導出するように整理し、グラフと KPI が常に一致するよう保証',
  },
  {
    version: 'ver.1.2.4',
    date: '2026/5/8',
    description:
      'グラフ表示を改善。(1) 月間／週間モードのグラフを「単月/単週 1 点」から「日別ポイント」に変更。指定月の各日（例: 5月なら31日分）または指定週の 7 日分が並ぶ。L/D 切替時はトランザクションの accountTime ベースで日別 L/D 集計。F/L/家賃/固定費は月額/30 で日割り。(2) 売上タブの「客単価」線が左軸（売上 数百万円）に貼り付いて見えなかった問題を修正。客単価を右軸（来客数・F/D 注文数と同じ）に移動して可視化',
  },
  {
    version: 'ver.1.2.3',
    date: '2026/5/8',
    description:
      'L/D（ランチ／ディナー）切替時の FL 率と利益を正しく算出するよう修正。Airレジ会計明細の accountTime ベースで集計済みの lunchSales/dinnerSales を使い、選択時間帯の売上比でF（食材費）・L（人件費）・家賃・固定費を按分。例: ディナー売上が全時間帯の 80% なら、コストもそれぞれ 80% 分を計上。これで FL 率、利益、構成比がランチ／ディナー別に経営判断できる。注釈にも按分比率を表示',
  },
  {
    version: 'ver.1.2.2',
    date: '2026/5/8',
    description:
      'トップページの期間選択を全面強化。(1) 月途中の日割り対応：選択期間の実日数（今日以降は除外）を計算し、家賃・固定費・人件費（固定値モード）の月額を「実日数 / 30」で按分。当月を選んでも FL 率がマイナスにならず現実的な値になる。(2) 週間モードを ISO 週直接入力から「日付選択 + 前週/次週ボタン + 範囲表示」に改善。(3) 年間モードに 3 種類のサブモードを追加：「直近12ヶ月」「暦年（1月〜12月）」「年度（8月〜翌7月、決算月起算）」。(4) カスタム期間モード（任意の開始日〜終了日）を新設。(5) 集計期間と実日数をフィルター直下に常時表示。グラフの各月／週も実日数で按分するため、当月・当週点も整合する',
  },
  {
    version: 'ver.1.2.1',
    date: '2026/5/8',
    description:
      '人件費の月額固定値（暫定）入力機能を追加。freee 等の会計連携が稼働するまでの仮値として LaborCostItem を新設（PK=STORE#&lt;id&gt;, SK=LABORCOSTITEM#&lt;itemKey&gt;）。/labor 上部に固定費と同形式のグリッド入力 UI を配置し、既定項目（正社員給与・アルバイト/パート給与・法定福利費・福利厚生費）＋追加可。トップページの人件費 KPI は LaborCostItem 登録時はそちらを優先、未登録時は従来の Airシフト × スタッフマスタ実労働ベース算出にフォールバック。Excel 2025年平均から席数比按分で各店舗に初期値を投入',
  },
  {
    version: 'ver.1.2.0',
    date: '2026/5/8',
    description:
      '固定費・家賃のデータモデルを刷新。(1) 月別の FixedCostEntry を廃止し、店舗別×項目別の月額固定値（FixedCostItem）に統一。家賃も itemKey="rent" として同テーブルで管理。(2) Store.monthlyRent を廃止し、店舗マスタから家賃欄を撤去。(3) FixedCostPage を月選択廃止＋店舗×項目グリッドの常時編集 UI に再設計。家賃行は薄黄色でハイライト・削除不可。(4) DashboardPage の家賃／その他固定費 KPI は FixedCostItem の月額×期間月数で算出。(5) 既存 FIXEDCOST# レコード 290 件と Store.monthlyRent を削除し、2025年の年間平均から算出した月額固定値を投入',
  },
  {
    version: 'ver.1.1.6',
    date: '2026/5/8',
    description:
      'トップページ初期値と表記の調整：(1) 期間切替の初期値を「年間」→「月間」に変更（普段の経営判断は当月単位が中心のため）。(2) 食材ページのナビ／ページタイトルを「食材」→「食材費」に表記統一。(3) 店舗マスタの営業時間帯を投入（西本町: ランチ 11:00-15:00 / ディナー 18:00-23:00、好EN: ディナー 17:00-24:00 のみ）。トップページに「ランチ」チップが出るようになった。(4) Aggregator Lambda の店舗マスタキャッシュに 5 分 TTL を追加し、マスタ更新が短時間で反映されるよう改善。(5) 固定費の実データ（2025/01〜2026/04）290 レコードを席数比 30.6:69.4 で按分投入',
  },
  {
    version: 'ver.1.1.5',
    date: '2026/5/8',
    description:
      '人件費の算出ソースを Airメイト連携から Airシフト × スタッフマスタの直接計算に変更。(1) 共通ユーティリティ frontend/src/lib/laborCost.ts を新設し、月単位で按分してから合算するロジックを LaborPage と DashboardPage で共有。役員・正社員=月給 × 当該月の店舗勤務時間比、アルバイト・スポット=時給 × 実労働時間。(2) トップページの人件費 KPI／PL グラフを Airシフトベースに切替。(3) 食材ページを食材費（原価）専用にスリム化（人件費・FL率 KPI を削除、食材費＋食材費率のみ表示）。(4) MCP get_cost_entries の既定フィルタを reportInput="あり" かつ category!="人件費" に変更し、人件費は list_staff＋get_shifts から再計算する旨を docstring に明記',
  },
  {
    version: 'ver.1.1.4',
    date: '2026/5/8',
    description:
      '食材ページ整理：(1) ページタイトルを「原価管理」→「食材」に修正（ナビと統一）。(2) Airメイト「月次コスト管理」日割りデータを表示する参考用チェックボックスを廃止し、常に除外する運用に統一。家賃・固定費はダッシュボードの店舗マスタ／固定費ページで直接入力する方針を注記',
  },
  {
    version: 'ver.1.1.3',
    date: '2026/5/8',
    description:
      'トップページの視認性向上：(1) PL 構成カード（F/L/家賃/その他/利益）すべてに目標値との進捗バーを追加。経費系は超過時、利益は不足時に赤強調。負値の利益でも安全に描画。(2) FL 率カードのプログレスバーをカード全幅の独立行に再配置（従来は %数字の真下）。目標 55% ラインがカード横全体に広がり視認性アップ',
  },
  {
    version: 'ver.1.1.2',
    date: '2026/5/8',
    description:
      'トップページ KPI を整理：(1) Row A の食材費率 F・人件費率 L カードを Row B と重複していたため削除し、FL 率を「(食材費 + 人件費) ÷ 売上」の分数形式で大きく表示するカードに統合。金額・分数・%・vs 目標バーを 1 枚で確認できる。(2) 期間切替の「週間」を「直近 1 週間」に変更（旧称「週間（12週）」）。週間モードでは KPI が選択 ISO 週の単一週分集計になり、家賃・固定費は月額の 7/30 で日割り。グラフは参考として 12 週推移を維持し、明示的な注記を追加',
  },
  {
    version: 'ver.1.1.1',
    date: '2026/5/8',
    description:
      '家賃の運用を簡易化：月別グリッド入力（家賃ページ）を廃止し、店舗マスタの固定値（Store.monthlyRent）に統合。家賃 KPI・PL グラフはこの固定値を毎月参照する。/rent URL は /settings/stores へリダイレクト。実値投入：西本町店 ¥176,000／好EN ¥330,000',
  },
  {
    version: 'ver.1.1.0',
    date: '2026/5/8',
    description:
      '経営判断指標ダッシュボード刷新（Phase A〜D 完了）。FL 比率／PL 構成比（F/L/家賃/他/利益）／借入の KPI・グラフを中心に再設計。トップページに 3 軸フィルター（店舗 全社合算／個別、期間 年間／月間／週間、時間帯 全/ランチ/ディナー）。新メニュー：売上 / 食材 / 人件費 / 家賃 / 固定費 / 借入 / 設定（CSV取込/目標値/店舗マスタ）。家賃・固定費・借入の手動入力 UI、店舗マスタの営業時間帯（ランチ／ディナー）とドリンク判定キーワード、目標値の構成比拡張（家賃率/他率/利益率）、構成比ベンチマーク（F:30/L:30/家:10/他:20/利:10、FL≤55%）の全社デフォルト適用。Aggregator にランチ／ディナー集計とフード／ドリンク注文数を追加。旧 URL（/products → /sales 等）からの自動リダイレクト',
  },
  {
    version: 'ver.1.0.30',
    date: '2026/5/3',
    description:
      'ダッシュボードのログイン方式を pengi-agent と同じパスワードレス認証に変更。メール確認コードによるログインと PassKey ログイン、アカウント画面での PassKey 登録に対応',
  },
  {
    version: 'ver.1.0.29',
    date: '2026/5/3',
    description:
      'AGENTS.md、CLAUDE.md、README.md に独自ドメイン、pengi-agent 共有 Cognito、サブモジュール更新運用、ループ社向けペンジーくんデプロイスクリプトの内容を反映',
  },
  {
    version: 'ver.1.0.28',
    date: '2026/5/3',
    description:
      'ダッシュボードを dashboard.loophamburg.onocomm.jp、ペンジーくんを pengi.loophamburg.onocomm.jp で利用する構成に変更。Amplify 認証トークンを .loophamburg.onocomm.jp スコープの Cookie に保存し、サブドメイン間のログイン状態共有に対応',
  },
  {
    version: 'ver.1.0.27',
    date: '2026/5/3',
    description:
      'ダッシュボードの Cognito 認証を pengi-agent 側でデプロイした UserPool / Client に統一。AppSync と MCP の Cognito 認可も同じ UserPool を参照する構成に変更',
  },
  {
    version: 'ver.1.0.26',
    date: '2026/5/3',
    description:
      'pengi-agent を Git サブモジュールとして追加し、ヘッダーメニューからペンジーくん（CloudFront デフォルトドメイン）へ別タブで遷移できる導線を追加',
  },
  {
    version: 'ver.1.0.25',
    date: '2026/4/28',
    description:
      'CLAUDE.md と README.md を最新の実装内容に更新（4 CDK スタック、MCP サーバー、全機能、データソース信頼性、CI/CD 等を反映）',
  },
  {
    version: 'ver.1.0.24',
    date: '2026/4/28',
    description:
      'MCP サーバー Phase C 完了。Resources（loop://stores, loop://staff, loop://import-history/recent）と Prompts（weekly_business_review, pl_estimate, staff_cost_breakdown）を追加。リポジトリ内ファイルは公開せずデータのみ提供',
  },
  {
    version: 'ver.1.0.23',
    date: '2026/4/28',
    description:
      'MCP サーバー Phase B 完了。9 ツールすべて実装：list_stores / get_monthly_summary / get_weekly_summary / get_transactions / get_cost_entries / list_staff / get_shifts / get_targets / get_import_history。各ツールに信頼性メモ付きの日本語 description を埋め込み',
  },
  {
    version: 'ver.1.0.22',
    date: '2026/4/28',
    description:
      'モノリポ構成として mcp-server/（Python + FastMCP）と pengi-agent/（将来サブモジュール）を追加。AWS Bedrock AgentCore Runtime に MCP サーバーをデプロイする McpStack を CDK に追加（Phase A: list_stores 1 ツールから開始、Cognito JWT 認可）',
  },
  {
    version: 'ver.1.0.21',
    date: '2026/4/28',
    description:
      'Cognito UserPool のパスワードポリシーを minLength: 12 → 8 に緩和（運用の覚えやすさ重視）。大文字・小文字・数字必須は維持',
  },
  {
    version: 'ver.1.0.20',
    date: '2026/4/28',
    description:
      'スタッフを店舗別管理から全社管理（PK=GLOBAL）に変更。掛け持ちスタッフは同一レコードで給与1セット、店舗ごとの勤務時間で自動按分（月給型は時間比、時給型は実労働×時給）。/staff ページに店舗別勤務・按分人件費の列を追加',
  },
  {
    version: 'ver.1.0.19',
    date: '2026/4/28',
    description:
      'スタッフマスタに「役員」雇用区分を追加。/staff ページにスタッフの新規追加フォームと削除ボタンを実装（admin 限定）。upsertStaff Mutation に displayName 引数を追加し UI からの新規登録に対応。deleteStaff Mutation を新規追加',
  },
  {
    version: 'ver.1.0.18',
    date: '2026/4/28',
    description:
      'シフトレコードの SK に開始/終了時間を含めて一意化（同一日・同一スタッフが複数シフト＝休憩挟み等で BatchWrite が duplicate keys エラーになる不具合を修正）。SK 形式: SHIFT#date#staffKey#start-end',
  },
  {
    version: 'ver.1.0.17',
    date: '2026/4/28',
    description:
      '.env による Cognito/AppSync 設定を廃止し frontend/src/config/aws.ts に集約（公開情報のみのため git 追跡対象として明示管理）。.env は機密混入リスクがあるため使わない方針に統一。GitHub Actions の .env 生成ステップも削除',
  },
  {
    version: 'ver.1.0.16',
    date: '2026/4/28',
    description:
      'GitHub Actions ビルド時に「Auth UserPool not configured」となる不具合を修正。CloudFormation Outputs から VITE_USER_POOL_ID 等を動的取得して frontend/.env を生成するステップを追加（.env は .gitignore 対象のため CI では生成必須）',
  },
  {
    version: 'ver.1.0.15',
    date: '2026/4/28',
    description:
      'GitHub Actions による CDK 自動デプロイを追加。OIDC 認証で IAM Role（LoopDashboardGitHubActionsDeploy）を AssumeRole し、CDK Bootstrap が作る専用 Role を経由してデプロイ。main ブランチへの push（cdk/frontend/lambda/shared 配下）で自動実行',
  },
  {
    version: 'ver.1.0.14',
    date: '2026/4/28',
    description:
      'shifts クエリの SK BETWEEN 上限文字を `#~`（ASCII U+007E）から U+FFFD に変更。SHIFT#date#<日本語スタッフ名> のとき、日本語が `~` より大きいコードポイントを持つため対象月最終日のシフトが取れない不具合を修正',
  },
  {
    version: 'ver.1.0.13',
    date: '2026/4/28',
    description:
      'Airシフト「シフトデータ」CSV 取込と人件費ページ（/staff）を追加。スタッフごとに雇用区分（正社員/アルバイト/スポット）と時給/月給を設定し、実労働時間 × 時給 or 月給固定で正確な人件費を算出。アルバイト・正社員を統合した実態人件費の把握が可能に',
  },
  {
    version: 'ver.1.0.12',
    date: '2026/4/28',
    description:
      '原価管理の人件費取扱いを変更。Airシフト連携（=アルバイト人件費）は信頼できる時給制スタッフ分として採用、KPI を「アルバイト人件費」「アルバイト人件費率」「FL率（アルバイト分）」にリネーム。正社員給与は別途取扱いとなる旨をバナーで明示',
  },
  {
    version: 'ver.1.0.11',
    date: '2026/4/28',
    description:
      '原価管理ページで「日報入力＝あり」のみをデフォルト集計対象に変更（Airメイトの月次コスト管理日割り＝地代家賃・減価償却・通信費・Web広告等／Airシフト連携の人件費は信頼性が低いため除外）。チェックボックスで参考表示も可能',
  },
  {
    version: 'ver.1.0.10',
    date: '2026/4/28',
    description:
      'Query.stores の Scan limit を 100 から 10000 に拡張（取引／コスト件数が増えると Scan の早期打ち切りで店舗マスタが取得できなくなる事象を解消）',
  },
  {
    version: 'ver.1.0.9',
    date: '2026/4/28',
    description:
      'Airメイトの「日次コスト明細」CSV 取込と原価管理ページ（/costs）を追加。日次／週次／月次の積上げグラフ、原価率・人件費率・FL 率 KPI、分類別／項目別の内訳テーブルを表示。店舗マスタに Airメイト AKR フィールドを追加（CSV 内 AKR から storeId を自動解決）',
  },
  {
    version: 'ver.1.0.8',
    date: '2026/4/28',
    description:
      '店舗選択を localStorage に永続化（ダッシュボード／商品分析／CSV 取込／目標値の各ページ間およびリロード後に選択状態を維持。別タブとも同期）',
  },
  {
    version: 'ver.1.0.7',
    date: '2026/4/28',
    description:
      'aggregator Lambda の月末計算バグを修正（常に「YYYY-MM-31」を生成しており、4月・6月・9月・11月・2月で無効な日付となり AppSync の AWSDate シリアライズエラーで月次サマリが取得できなかった）',
  },
  {
    version: 'ver.1.0.6',
    date: '2026/4/28',
    description:
      'raw バケットに CORS 設定を追加（CloudFront ドメインと localhost:5173 から PUT を許可）。CSV アップロード時に「Failed to fetch」となっていた問題を解消',
  },
  {
    version: 'ver.1.0.5',
    date: '2026/4/28',
    description:
      'CSV アップロードリゾルバの不具合を修正。requestCsvUploadUrl の VTL マッピングに storeId を追加（Lambda へ店舗 ID が渡らず常に「storeId 必須」エラーで失敗していた）。GraphQL エラーメッセージが画面で undefined と表示されていた問題も改善',
  },
  {
    version: 'ver.1.0.4',
    date: '2026/4/28',
    description:
      'AppSync の defaultAction を DENY から ALLOW に変更し、認証済みユーザーが各クエリにアクセスできない不具合を修正（admin 限定操作は @aws_auth で個別制御）',
  },
  {
    version: 'ver.1.0.3',
    date: '2026/4/28',
    description: 'バージョン表示機能を追加（ヘッダーに最新バージョン、/version で履歴一覧）',
  },
  {
    version: 'ver.1.0.2',
    date: '2026/4/28',
    description: '店舗マスタの登録・編集画面を追加（admin 権限）。初期店舗（ループ ハンバーグ西本町店、好EN）を登録',
  },
  {
    version: 'ver.1.0.1',
    date: '2026/4/28',
    description: 'CSV 取込対象を会計明細のみに統一（ジャーナル CSV を廃止）。Cognito 招待メールのテンプレートを日本語化し、パスワードを改行で分離',
  },
  {
    version: 'ver.1.0.0',
    date: '2026/4/27',
    description: 'Phase 1 MVP を実装。Cognito 認証、Airレジ会計明細 CSV 取込、ダッシュボード、商品分析、目標値設定',
  },
];

export const getLatestVersion = (): string =>
  versionHistory[0]?.version ?? 'ver.0.0.0';

export const Version = (): React.JSX.Element => {
  const navigate = useNavigate();
  return (
    <div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: '1rem',
        }}
      >
        <h1 style={{ margin: 0, fontSize: '1.4rem' }}>バージョン履歴</h1>
        <button type="button" onClick={() => navigate(-1)} style={backBtn}>
          戻る
        </button>
      </div>
      <div style={card}>
        <table style={tableStyle}>
          <thead>
            <tr>
              <th style={th}>バージョン</th>
              <th style={th}>日付</th>
              <th style={th}>変更内容</th>
            </tr>
          </thead>
          <tbody>
            {versionHistory.map((v) => (
              <tr key={v.version}>
                <td style={{ ...td, fontWeight: 600, fontFamily: 'monospace' }}>
                  {v.version}
                </td>
                <td style={{ ...td, whiteSpace: 'nowrap', color: '#6c757d' }}>
                  {v.date || '-'}
                </td>
                <td style={td}>{v.description}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const card: React.CSSProperties = {
  background: '#fff',
  borderRadius: 2,
  padding: '0.5rem 1rem',
  boxShadow: 'none',
  border: '1px solid #d4d1cf',
};
const tableStyle: React.CSSProperties = {
  width: '100%',
  borderCollapse: 'collapse',
  fontSize: '0.9rem',
};
const th: React.CSSProperties = {
  textAlign: 'left',
  padding: '0.6rem 0.8rem',
  borderBottom: '1px solid #dee2e6',
  background: '#f8f9fa',
};
const td: React.CSSProperties = {
  padding: '0.6rem 0.8rem',
  borderBottom: '1px solid #f1f3f5',
  verticalAlign: 'top',
};
const backBtn: React.CSSProperties = {
  padding: '0.4rem 0.9rem',
  borderRadius: 6,
  border: '1px solid #ced4da',
  background: '#fff',
  cursor: 'pointer',
  fontSize: '0.85rem',
};
